// extracted by mini-css-extract-plugin
export default {"list__container":"PeopleList_list__container__NwJ33","list__item":"PeopleList_list__item__mI12e","list__img_person":"PeopleList_list__img_person__xcgvb"};